import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResolverService } from '../services/resolve/resolver-analytics.service';
import { AppShellComponent } from './app-shell/app-shell.component';
import { DefectsListComponent } from './defects-list/defects-list.component';

const routes: Routes = [
  {
    path: '',
    component: AppShellComponent,
    children: [
      {
        path: 'page-analytics',
        loadChildren: () => import('../analytics/analytic.module').then((m) => m.AnalyticModule),
        resolve: {
          __DO_NOT_USE_THIS__: ResolverService,
        },
        data: { preload: true, delay: false },
      },
      {
        path: 'page-mm-analytics',
        loadChildren: () => import('../analytics/analytic.module').then((m) => m.AnalyticModule),
        resolve: {
          __DO_NOT_USE_THIS__: ResolverService,
        },
        data: { preload: true, delay: true },
      },
      {
        path: 'page-skilli8-analytics',
        loadChildren: () => import('../analytics/analytic.module').then((m) => m.AnalyticModule),
        resolve: {
          __DO_NOT_USE_THIS__: ResolverService,
        },
        data: { preload: true, delay: true },
      },
      {
        path: 'page-reports',
        loadChildren: () => import('../reporting/reporting.module').then((m) => m.NspReportingModule),
        data: { preload: true, delay: true },
      },
      {
        path: 'reports-v2',
        loadChildren: () => import('../reports-v2/report-v2.module').then((m) => m.ReportsV2Module),
        data: { preload: true, delay: true },
      },
      {
        path: 'page-orders',
        loadChildren: () => import('../order-module/order-landing.module').then((m) => m.OrderLandingPageModule),
        data: { preload: true, delay: true },
      },
      {
        path: 'defects-list',
        component: DefectsListComponent,
        data: { preload: true, delay: true },
      },
      {
        path: '**',
        redirectTo: 'page-analytics',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppShellRoutingModule {}
